module.exports = __webpack_public_path__ + "static/media/background-lances.27ef56ba.svg";